import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cssbuy.biz";

const listItems1 = [
  "Abas separadas por categoria (Shoes, T-Shirts, Jackets, etc.)",
  "Links diretos para páginas de vendedores verificados",
  "Informações sobre preço e qualidade de cada produto",
  "Álbuns Yupoo organizados com fotos dos produtos",
  "Guias e dicas inseridos diretamente na planilha",
];

const vantagens = [
  { t: "Economia de Tempo", d: "Encontre produtos em segundos, sem precisar navegar por dezenas de sites e fóruns diferentes." },
  { t: "Links Verificados", d: "Cada link da nossa planilha é testado manualmente antes de ser publicado, garantindo qualidade." },
  { t: "Atualização Diária", d: "A planilha é atualizada todos os dias com novos produtos e remoção de links quebrados." },
  { t: "Organização por Categoria", d: "Navegação intuitiva por categorias facilita encontrar exatamente o que você procura." },
];

const faqItems = [
  { q: "A planilha CSSBuy é realmente gratuita?", a: "Sim! Nossa planilha CSSBuy é completamente gratuita. Não cobramos nada pelo acesso aos links e guias. Nosso objetivo é ajudar a comunidade brasileira a fazer compras internacionais com mais segurança e economia." },
  { q: "Com que frequência novos produtos são adicionados?", a: "Adicionamos novos produtos diariamente à planilha CSSBuy. Nossa equipe está constantemente buscando os melhores vendedores e as tendências mais recentes para manter o conteúdo sempre atualizado e relevante." },
  { q: "Posso confiar em todos os links da planilha?", a: "Sim. Cada link em nossa planilha CSSBuy passa por um rigoroso processo de verificação. Testamos pessoalmente os vendedores e monitoramos avaliações da comunidade antes de incluir qualquer link na planilha." },
];

export default function PlanilhaCssbuyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"Article",
        "headline":"Planilha CSSBuy: O Guia Definitivo para Compras Internacionais",
        "url": `${SITE_URL}/planilha-cssbuy`,
        "author":{"@type":"Person","name":"Equipe CSSBuy Brasil"},
        "datePublished":"2026-06-15","dateModified":"2026-06-27",
        "publisher":{"@type":"Organization","name":"CSSBuy Brasil","url": SITE_URL},
        "inLanguage":"pt-BR"
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"BreadcrumbList",
        "itemListElement":[
          {"@type":"ListItem","position":1,"name":"Início","item": `${SITE_URL}/`},
          {"@type":"ListItem","position":2,"name":"Planilha CSSBuy Guia Definitivo","item": `${SITE_URL}/planilha-cssbuy`}
        ]
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"FAQPage",
        "mainEntity":[
          {"@type":"Question","name":"A planilha CSSBuy é realmente gratuita?","acceptedAnswer":{"@type":"Answer","text":"Sim! Nossa planilha CSSBuy é completamente gratuita. Não cobramos nada pelo acesso aos links e guias. Nosso objetivo é ajudar a comunidade brasileira a fazer compras internacionais com mais segurança e economia."}},
          {"@type":"Question","name":"Com que frequência novos produtos são adicionados?","acceptedAnswer":{"@type":"Answer","text":"Adicionamos novos produtos diariamente à planilha CSSBuy. Nossa equipe está constantemente buscando os melhores vendedores e as tendências mais recentes para manter o conteúdo sempre atualizado e relevante."}},
          {"@type":"Question","name":"Posso confiar em todos os links da planilha?","acceptedAnswer":{"@type":"Answer","text":"Sim. Cada link em nossa planilha CSSBuy passa por um rigoroso processo de verificação. Testamos pessoalmente os vendedores e monitoramos avaliações da comunidade antes de incluir qualquer link na planilha."}}
        ]
      })}} />

      <Navbar />
      <main>
        <article className="pt-24 pb-16 md:pt-28 md:pb-24">
          <div className="max-w-4xl mx-auto px-4 md:px-8 mb-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400">
              <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">Início</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">Planilha CSSBuy Guia Definitivo</span>
            </nav>
          </div>

          <header className="max-w-4xl mx-auto px-4 md:px-8 mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">Planilha</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Planilha CSSBuy: O Guia Definitivo para Compras Internacionais
            </h1>
            <p className="mt-4 text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl">
              Aprenda tudo sobre a <strong>planilha CSSBuy</strong>: como acessar, navegar pelas categorias e encontrar os melhores produtos com links verificados e atualizados diariamente.
            </p>
            <div className="flex flex-wrap items-center gap-4 mt-6 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-user-line"></i>Equipe CSSBuy Brasil</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-calendar-line"></i>Atualizado: Junho 2026</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-time-line"></i>7 min de leitura</span>
            </div>
            <div className="mt-8 rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
              <img src="https://readdy.ai/api/search-image?query=Minimalist%20desk%20workspace%20with%20printed%20spreadsheet%20documents%20and%20fashion%20items%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20photography%20clean%20composition%20neutral%20beige%20background%20organized%20aesthetic%20professional%20planning%20theme&width=1200&height=600&seq=art-page-planilha-cssbuy&orientation=landscape" alt="Planilha CSSBuy" className="w-full h-full object-cover" />
            </div>
          </header>

          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div className="text-foreground-700 leading-relaxed space-y-8">
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">O que é a Planilha CSSBuy?</h2>
                <p className="text-base leading-relaxed">
                  A <strong>planilha CSSBuy</strong> é uma ferramenta essencial para compradores brasileiros que utilizam o agente CSSBuy para compras internacionais. Trata-se de um documento organizado com milhares de <strong>CSSBuy links</strong> verificados e atualizados diariamente, cobrindo todas as categorias de produtos mais procuradas.
                </p>
                <p className="text-base leading-relaxed mt-4">
                  Diferente de outras <strong>spreadsheet CSSBuy</strong> disponíveis online, nossa <strong>planilha CSSBuy</strong> é mantida por uma equipe dedicada que verifica manualmente cada link, garantindo que você encontre apenas vendedores confiáveis e produtos com qualidade comprovada.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Como Acessar e Navegar na Planilha CSSBuy</h2>
                <p className="text-base leading-relaxed">
                  Acessar nossa <strong>planilha CSSBuy</strong> é simples e gratuito. Basta clicar no link principal e você terá acesso imediato a todas as categorias organizadas. A planilha é dividida em abas por categoria de produto, facilitando a navegação entre diferentes tipos de itens.
                </p>
                <div className="mt-6 bg-background-100 rounded-2xl p-6">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">Estrutura da Planilha CSSBuy:</h3>
                  <ul className="space-y-3">
                    {listItems1.map((item, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm">
                        <i className="ri-checkbox-circle-fill text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Vantagens de Usar Nossa Planilha CSSBuy</h2>
                <p className="text-base leading-relaxed">
                  Utilizar uma <strong>planilha CSSBuy</strong> organizada traz inúmeras vantagens para o comprador brasileiro. A principal delas é a economia de tempo: em vez de passar horas procurando produtos em fóruns e redes sociais, você tem tudo organizado em um único lugar.
                </p>
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {vantagens.map((item, i) => (
                    <div key={i} className="bg-background-100 rounded-xl p-4">
                      <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{item.t}</h4>
                      <p className="text-xs text-foreground-500">{item.d}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Como a Planilha CSSBuy é Atualizada</h2>
                <p className="text-base leading-relaxed">
                  Nossa equipe dedicada trabalha diariamente para manter a <strong>planilha CSSBuy</strong> sempre atualizada. O processo de atualização inclui verificação de links existentes, adição de novos produtos populares, remoção de itens indisponíveis e avaliação contínua da qualidade dos vendedores.
                </p>
                <p className="text-base leading-relaxed mt-4">
                  A comunidade também contribui ativamente: usuários podem reportar links quebrados ou sugerir novos vendedores, tornando a <strong>spreadsheet CSSBuy</strong> um recurso colaborativo e cada vez mais completo para todos os compradores brasileiros.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Perguntas Frequentes</h2>
                <div className="space-y-4">
                  {faqItems.map((item, i) => (
                    <div key={i} className="bg-background-100 rounded-xl p-5">
                      <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.q}</h4>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section>
                <div className="bg-foreground-900 rounded-3xl p-8 md:p-10 text-center">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">Acesse a Planilha CSSBuy Agora</h2>
                  <p className="text-background-50/60 text-sm md:text-base max-w-lg mx-auto mb-6">Comece a usar a melhor planilha CSSBuy de 2026 com links verificados e atualizados diariamente.</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">cssbuy sheet<i className="ri-arrow-right-up-line ml-2"></i></a>
                    <Link to="/" className="px-8 py-3.5 rounded-full border border-background-50/20 text-background-50/70 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer">← Voltar ao Início</Link>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}